import { CommonResponse } from '@gtpl/shared-models/masters';
import { RmReWeighingResponse } from '@gtpl/shared-models/raw-material-procurement';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { IndentItemRequest } from './dto/indent-item-id.request';
import { ReWeighingItemsDto } from './dto/re-weighed-items.dto';
import { ReWeighIdRequest } from './dto/re-weighing-id.request';
import { ReWeighingDto } from './dto/re-weighment.dto';
import { RmReWeighingService } from './rm-re-weighing.service';

@ApiTags('rm-re-weighing')
@Controller('rm-re-weighing')
export class RmReWeighingController {
    constructor(private reWeighService: RmReWeighingService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }

    @Post('/createRmReWeighing')
    async createRmReWeighing(@Body() rmWeighingData: ReWeighingItemsDto): Promise<CommonResponse> {
        try {
            return await this.reWeighService.createRmReWeighing(rmWeighingData);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getRmReWeighingData')
    async getRmReWeighingData(@Body() req: IndentItemRequest): Promise<RmReWeighingResponse> {
        try {
            return await this.reWeighService.getRmReWeighingData(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(RmReWeighingResponse, error);
        }
    }

    @Post('/deleteReWeighItem')
    async deleteReWeighItem(@Body() req: ReWeighIdRequest): Promise<CommonResponse> {
        try {
            return await this.reWeighService.deleteReWeighItem(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    


}
